module.exports = __webpack_public_path__ + "img/f8-21.8f1e554a.png";